import React, { useEffect, useState } from "react";
import LoadingScreen from "./LoadingScreen";
import InputData from "./InputData";
import {
  userData,
  selectProductName,
  areObjectsEqual,
  formatValueUnit,
} from "../js/utils";
import "../css/DeliveryNotePanel.css";
import { post } from "../js/post";
import ButtonIconH from "./ButtonIconH";
import DataTable from "react-data-table-component";
import TooltipBox from "./Tooltip";
import Dropdown from "./Dropdown";
import CheckBox from "./CheckBox";
import PopupTitle from "../support-extra/components/PopupTitle";
import CatalogueItem from "../support-extra/components/CatalogueItem";
import { DeliveryNoteHeader } from "./DeliveryNoteHeader";
import { DeliveryNoteOptionsBox } from "./DeliveryNoteOptionsBox";
import { CodeScanningPanel } from "./CodeScanningPanel";
import { DeliveryNoteStepHandler } from "./DeliveryNoteStepHandler";
import { ProductFeatures } from "./ProductFeatures";
import { ProductPurchaseData } from "./ProductPurchaseData";
import { ProductSalesData } from "./ProductSalesData";
import { ProductStockDistribution } from "./ProductStockDistribution";
import { DeliveryNoteValidation } from "./DeliveryNoteValidation";
import { DeliveryNoteLabelEncoding } from "./DeliveryNoteLabelEncoding";
import {
  frameColumns,
  sunglassesColumns,
  salesFrameColumns,
  hearingAidsColumns,
  lensesColumns,
  contactLensesColumns,
  liquidColumns,
  variousColumns,
  purchaseHearingAidsColumns,
  purchaseLensesColumns,
  purchaseContactLensesColumns,
  purchaseLiquidsColumns,
  purchaseFrameColumns,
  purchaseVariousColumns,
  purchaseSunglassesColumns,
  salesHearingAidsColumns,
  salesLensesColumns,
  salesContactLensesColumns,
  salesLiquidsColumns,
  salesVariousColumns,
  salesSunglassesColumns,
  purchaseSummaryColumns,
  hearingAidsDistributionColumns,
  lensesDistributionColumns,
  contactLensesDistributionColumns,
  liquidDistributionColumns,
  frameDistributionColumns,
  variousDistributionColumns,
  sunglassesDistributionColumns,
  validationColumns,
  validationSummaryColumns,
  validationFinalSummaryColumns,
  labelEncodingHearingAidsColumns,
  labelEncodingLensesColumns,
  labelEncodingContactLensesColumns,
  labelEncodingLiquidsColumns,
  labelEncodingFrameColumns,
  labelEncodingSunglassesColumns,
  labelEncodingVariousColumns,
  rightStyle,
} from "../js/tableColumns";
import { selectedOptic } from "../js/utils";
import moment from "moment";
import { useOptics } from "../hooks/useOptics";

export default function DeliveryNotePanel({
  id,
  onClose,
  createPopupQuestion,
  removePopupQuestion,
  openProductPanel,
  createdProducts,
}) {
  const [loading, setLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState(0);
  const [toggleSelector, setToggleSelector] = useState(false);
  const opticalList = [{ id: "", text: "" }, ...useOptics()];
  const [startReading, setStartReading] = useState(false);
  const [currentHeader, setCurrentHeader] = useState(null);
  const [currentHeaderFixed, setCurrentHeaderFixed] = useState(null);
  const [currentProductFeatures, setCurrentProductFeatures] = useState([]);
  const [currentProductFeaturesFixed, setCurrentProductFeaturesFixed] =
    useState([]);
  const [currentPurchaseData, setCurrentPurchaseData] = useState([]);
  const [currentPurchaseDataFixed, setCurrentPurchaseDataFixed] = useState([]);
  const [currentSalesData, setCurrentSalesData] = useState([]);
  const [currentSalesDataFixed, setCurrentSalesDataFixed] = useState([]);
  const [currentStockDistribution, setCurrentStockDistribution] = useState([]);
  const [currentStockDistributionFixed, setCurrentStockDistributionFixed] =
    useState([]);
  const [currentValidationData, setCurrentValidationData] = useState([]);
  const [currentLabelEncoding, setCurrentLabelEncoding] = useState([]);
  const [purchaseSummary, setPurchaseSummary] = useState([]);
  const [currentId, setCurrentId] = useState(id);
  const [finalPurchaseSummary, setFinalPurchaseSummary] = useState([]);
  const [finalValidationSummary, setFinalValidationSummary] = useState([]);
  const [regProds, setRegProds] = useState(false);
  const [selectedDistributionStock, setSelectedDistributionStock] =
    useState("Individual");
  const [selectedCentralOptic, setSelectedCentralOptic] = useState({
    id: "",
    text: "",
  });
  const [showCataloguesPopup, setShowCataloguesPopup] = useState(false);
  const [catalogues, setCatalogues] = useState([]);

  let globalTabIndex = 15;

  // console.log("currentValidationData: ", currentValidationData);
  // console.log("currentLabelEncoding: ", currentLabelEncoding);

  function handleStartReading() {
    if (currentId === -1) {
      createPopupQuestion(
        `Para iniciar el registro de productos debe guardar primero la ficha de albarán.`,
        async () => {
          removePopupQuestion();
          await saveDeliveryNote();
        },
        removePopupQuestion,
        "Guardar",
        "Cancelar",
      );
    } else {
      setStartReading(true);
    }
  }

  async function handleSave(silent = false) {
    // console.log("SILENT: ", silent);
    const response = await saveDeliveryNote();
    if (response && !silent) {
      createPopupQuestion(
        currentHeader.borrador ? (
          `La ficha de albarán se ha guardado correctamente.`
        ) : (
          <>
            La ficha de albarán se ha guardado correctamente.
            <br />
            <br />
            <span style={{ fontWeight: 600 }}>Atención: </span>
            Este albarán se encuentra ya cerrado. En caso de haber realizado
            modificaciones en los precios de venta de los productos deberá
            reflejarlos en los almacenes de manera manual, pues solo han sido
            guardados en la información del albarán.
          </>
        ),
        removePopupQuestion,
        null,
        "Entendido",
      );
    }
  }

  function handleCloseScanningPanel() {
    setStartReading(false);
  }

  async function handlePreviousStep() {
    if (currentStep === 1) await handleSave(true);
    setCurrentStep(currentStep !== 0 ? currentStep - 1 : currentStep);
  }

  function handleNextStep() {
    const isStep2WithValidDistribution =
      currentStep !== 2 ||
      selectedDistributionStock === "Individual" ||
      (selectedDistributionStock === "Multicompra" && checkDistributionOK());

    const isNotFinalStep = currentStep !== 5;
    const isStep4Valid = currentStep !== 4 || !currentHeader.borrador;

    const canAdvance =
      isStep2WithValidDistribution &&
      isNotFinalStep &&
      isStep4Valid &&
      regProds;

    if (canAdvance) {
      setCurrentStep(currentStep + 1);
      return;
    }

    if (currentStep === 2 && selectedDistributionStock === "Multicompra") {
      createPopupQuestion(
        `Debe realizar una distribución correcta antes de continuar.`,
        removePopupQuestion,
        null,
        "Entendido",
      );
    }

    if (currentStep === 4) {
      createPopupQuestion(
        `Debe validar el albarán antes de continuar.`,
        removePopupQuestion,
        null,
        "Entendido",
      );
    }
  }

  function checkDistributionOK() {
    for (const family of currentStockDistribution) {
      for (const product of family.productos) {
        let total = 0;
        for (const optic of product.opticas) {
          total += optic.stock;
        }
        if (total !== product.stock) {
          return false;
        }
      }
    }
    return true;
  }

  async function getDeliveryNoteHeader() {
    const response = await post(
      "support-extra/albaran/ObtenerCabeceraAlbaran.php",
      {
        token: userData.token,
        id: currentId,
      },
    );

    const modifiedResponse = {
      ...response,
    };

    setCurrentHeader(modifiedResponse);
    setCurrentHeaderFixed(modifiedResponse);
    if (!response.borrador) {
      setCurrentStep(5);
    }
    setSelectedDistributionStock(response.tipoCompra);
    if (response.idOpticaOrigen !== "") {
      const centralOptic = {
        id: response.idOpticaOrigen,
        text: response.nombreOpticaOrigen,
      };
      setSelectedCentralOptic(centralOptic);
    }
  }

  async function saveDeliveryNoteHeader() {
    await post("support-extra/albaran/GuardarCabeceraAlbaran.php", {
      token: userData.token,
      idUsuario: userData.id,
      idAlbaran: currentId,
      idOptica: selectedOptic.id,
      ...currentHeader,
    });

    setCurrentHeaderFixed(currentHeader);
  }

  async function saveProductFeatures() {
    await post(
      "support-extra/albaran/ActualizarCaracteristicasProductoAlbaran.php",
      {
        token: userData.token,
        familias: currentProductFeatures,
      },
    );
    setCurrentProductFeaturesFixed(currentProductFeatures);
  }

  async function getDeliveryNoteAttributes() {
    const response = await post(
      "support-extra/albaran/ObtenerCaracteristicasProductoAlbaran.php",
      {
        token: userData.token,
        idAlbaran: currentId,
        idUsuario: userData.id,
      },
    );
    // console.log(
    // "OBTENER CARACTERISTICAS PRODUCTO: ",
    // {
    // token: userData.token,
    // idAlbaran: currentId,
    // idUsuario: userData.id,
    // },
    // response,
    // );

    setCurrentProductFeatures(response);
    setCurrentProductFeaturesFixed(response);
    setRegProds(response.some((e) => e.productos.length > 0));
  }

  async function getPurchaseDeliveryNoteData() {
    const response = await post(
      "support-extra/albaran/ObtenerDatosCompraAlbaran.php",
      {
        token: userData.token,
        idAlbaran: currentId,
        idOptica: selectedOptic.id,
      },
    );
    // console.log(
    // "OBTENER DATOS COMPRA: ",
    // {
    // token: userData.token,
    // idAlbaran: currentId,
    // idOptica: selectedOptic.id,
    // },
    // response,
    // );

    setCurrentPurchaseData(response);
    setCurrentPurchaseDataFixed(response);
  }

  async function getSalesDeliveryNoteData() {
    const response = await post(
      "support-extra/albaran/ObtenerDatosVentaAlbaran.php",
      {
        token: userData.token,
        idAlbaran: currentId,
      },
    );
    // console.log(
    // "OBTENER DATOS VENTA: ",
    // {
    // token: userData.token,
    // idAlbaran: currentId,
    // },
    // response,
    // );
    setCurrentSalesData(response);
    setCurrentSalesDataFixed(response);
  }

  async function getLabelEncodingDeliveryNoteData() {
    const response = await post(
      "support-extra/albaran/ObtenerDatosCodificacion.php",
      {
        token: userData.token,
        idAlbaran: currentId,
      },
    );
    // console.log(
    // "OBTENIENDO DATOS CODIFICACIÓN: ",
    // {
    // token: userData.token,
    // idAlbaran: currentId,
    // },
    // response,
    // );

    setCurrentLabelEncoding(response);
  }

  async function getDeliveryNoteStockDistribution() {
    const response = await post(
      "support-extra/albaran/ObtenerStockAlbaran.php",
      {
        token: userData.token,
        idAlbaran: currentId,
      },
    );
    // console.log(
    // "OBTENER STOCK ALBARAN: ",
    // {
    // token: userData.token,
    // idAlbaran: currentId,
    // },
    // response,
    // );
    setCurrentStockDistribution(response);
    setCurrentStockDistributionFixed(JSON.parse(JSON.stringify(response)));
  }

  function selectProductFamilyColumnsStep1(id) {
    const columns = {
      0: hearingAidsColumns,
      1: lensesColumns,
      2: contactLensesColumns,
      3: liquidColumns,
      4: frameColumns,
      5: variousColumns,
      6: sunglassesColumns,
    };
    return columns[id];
  }

  function selectProductFamilyColumnsStep2(id) {
    const columns = {
      0: purchaseHearingAidsColumns,
      1: purchaseLensesColumns,
      2: purchaseContactLensesColumns,
      3: purchaseLiquidsColumns,
      4: purchaseFrameColumns,
      5: purchaseVariousColumns,
      6: purchaseSunglassesColumns,
    };
    return columns[id];
  }

  function selectProductFamilyColumnsStep3(id) {
    const columns = {
      0: hearingAidsDistributionColumns,
      1: lensesDistributionColumns,
      2: contactLensesDistributionColumns,
      3: liquidDistributionColumns,
      4: frameDistributionColumns,
      5: variousDistributionColumns,
      6: sunglassesDistributionColumns,
    };
    return columns[id];
  }

  function selectProductFamilyColumnsStep4(id) {
    const columns = {
      0: salesHearingAidsColumns,
      1: salesLensesColumns,
      2: salesContactLensesColumns,
      3: salesLiquidsColumns,
      4: salesFrameColumns,
      5: salesVariousColumns,
      6: salesSunglassesColumns,
    };
    return columns[id];
  }

  function selectProductFamilyColumnsStep6(id) {
    const columns = {
      0: labelEncodingHearingAidsColumns,
      1: labelEncodingLensesColumns,
      2: labelEncodingContactLensesColumns,
      3: labelEncodingLiquidsColumns,
      4: labelEncodingFrameColumns,
      5: labelEncodingVariousColumns,
      6: labelEncodingSunglassesColumns,
    };
    return columns[id];
  }

  async function saveDeliveryNotePurchaseData() {
    await post("support-extra/albaran/GuardarDatosCompraAlbaran.php", {
      token: userData.token,
      idAlbaran: currentId,
      datosCompra: currentPurchaseData,
      idOptica: selectedOptic.id,
    });

    setCurrentPurchaseDataFixed(currentPurchaseData);
  }

  async function saveDeliveryNoteSalesData() {
    await post("support-extra/albaran/GuardarDatosVentaAlbaran.php", {
      token: userData.token,
      idAlbaran: currentId,
      datosVenta: currentSalesData,
    });

    setCurrentSalesDataFixed(currentSalesData);
  }

  async function saveDeliveryNoteDistributionStock() {
    const distributionData = currentStockDistribution.map((familia) => ({
      familia: familia.familia,
      productos: familia.productos.map((producto) => ({
        idProductoAlbaran: producto.idProductoAlbaran,
        opticas: producto.opticas,
      })),
    }));
    await post("support-extra/albaran/GuardarDistribucionStock.php", {
      token: userData.token,
      idAlbaran: currentId,
      tipoCompra: selectedDistributionStock,
      idOpticaOrigen: selectedOptic.id,
      productos:
        selectedDistributionStock === "Individual" ? [] : distributionData,
    });

    setCurrentStockDistributionFixed(currentStockDistribution);
  }

  async function saveDeliveryNote() {
    if (currentHeader.idProveedor === "") {
      createPopupQuestion(
        `Rellene los campos obligatorios antes de continuar.`,
        removePopupQuestion,
        null,
        "Entendido",
      );
      return false;
    }

    await saveDeliveryNoteHeader();
    await saveProductFeatures();
    await saveDeliveryNotePurchaseData();
    await saveDeliveryNoteSalesData();
    await saveDeliveryNoteDistributionStock();
    return true;
  }

  async function deleteDeliveryNote() {
    createPopupQuestion(
      `¿Desea eliminar el albarán actual?`,
      async () => {
        await removeDeliveryNote();
        removePopupQuestion();
        onClose();
      },
      removePopupQuestion,
      "Sí",
      "No",
    );
  }

  async function removeDeliveryNote() {
    await post("support-extra/albaran/EliminarAlbaran.php", {
      token: userData.token,
      idAlbaran: currentId,
      idUsuario: userData.id,
    });
  }

  async function registerProduct(family, product, stock) {
    setRegProds(true);

    setCurrentProductFeatures((prevList) => {
      const updatedList = prevList.map((e) => {
        if (e.familia === family) {
          const productFound = e.productos.find(
            (p) => p.idProductoAlbaran === product.idProductoAlbaran,
          );

          if (productFound) {
            return {
              ...e,
              productos: e.productos.map((p) =>
                p.idProductoAlbaran === product.idProductoAlbaran
                  ? { ...p, stock: p.stock + parseInt(stock) }
                  : p,
              ),
            };
          }

          return {
            ...e,
            productos: [...e.productos, product],
          };
        }

        return e;
      });

      setCurrentProductFeaturesFixed(updatedList);

      return updatedList;
    });

    await getPurchaseDeliveryNoteData();
    await getSalesDeliveryNoteData();
    await getDeliveryNoteStockDistribution();
    await getLabelEncodingDeliveryNoteData();
  }

  async function deleteProductFromAPI(family, productId) {
    await post("support-extra/albaran/EliminarProductoAlbaran.php", {
      token: userData.token,
      familia: family,
      idProductoAlbaran: productId,
      idUsuario: userData.id,
    });
  }

  async function deleteProduct(family, productId) {
    await deleteProductFromAPI(family, productId);
    deleteProductFromList(family, productId);
    await getSalesDeliveryNoteData();
    await getPurchaseDeliveryNoteData();
    await getDeliveryNoteStockDistribution();
    await getLabelEncodingDeliveryNoteData();
  }

  async function deleteAllProducts(family, products) {
    for (const product of products) {
      const productId = product.idProductoAlbaran;
      await deleteProduct(family, productId);
    }
  }

  function deleteProductFromList(family, productId) {
    setCurrentProductFeatures((prevList) => {
      const updatedList = prevList.map((e) => {
        if (e.familia === family) {
          return {
            ...e,
            productos: e.productos.filter(
              (p) => p.idProductoAlbaran !== productId,
            ),
          };
        }
        return e;
      });
      setCurrentProductFeaturesFixed(updatedList);
      return updatedList;
    });
  }

  function handlePurchaseProductChange(familyId, summary, productList) {
    setPurchaseSummary((prev) =>
      prev.map((item, i) => (i === familyId ? summary : item)),
    );
    setCurrentPurchaseData((prev) =>
      prev.map((e) => {
        if (e.familia === familyId) {
          return {
            ...e,
            productos: productList.filter(
              (e) => e.idProductoAlbaran !== "summary",
            ),
          };
        }
        return e;
      }),
    );
  }

  function handleSalesProductChange(familyId, productList) {
    setCurrentSalesData((prev) =>
      prev.map((e) => {
        if (e.familia === familyId) {
          return {
            ...e,
            productos: productList,
          };
        }
        return e;
      }),
    );
  }

  function handleStockDistributionProductChange(familyId, productList) {
    setCurrentStockDistribution((prev) =>
      prev.map((e) => {
        if (e.familia === familyId) {
          return {
            ...e,
            productos: productList,
          };
        }
        return e;
      }),
    );
  }

  function refineProductsForValidation() {
    let mergedData = currentPurchaseData.map((purchaseFamily) => {
      const stockFamily = currentStockDistribution.find(
        (stockFam) => stockFam.familia === purchaseFamily.familia,
      );

      const salesFamily = currentSalesData.find(
        (salesFam) => salesFam.familia === purchaseFamily.familia,
      );

      return {
        ...purchaseFamily,
        productos: purchaseFamily.productos.map((purchaseProduct) => {
          const stockProduct = stockFamily?.productos.find(
            (stockProd) =>
              stockProd.idProductoAlbaran === purchaseProduct.idProductoAlbaran,
          );

          const salesProduct = salesFamily?.productos.find(
            (salesProd) =>
              salesProd.idProductoAlbaran === purchaseProduct.idProductoAlbaran,
          );

          return {
            ...purchaseProduct,
            opticas: stockProduct?.opticas || purchaseProduct.opticas,
            pvp: salesProduct?.pvp || purchaseProduct.pvp,
          };
        }),
      };
    });

    setCurrentValidationData(mergedData);
  }

  async function initializeStructures() {
    setCurrentHeader({
      numeroAlbaran: "",
      fechaAlbaran: moment().format("YYYY-MM-DD"),
      proveedor: "",
      tipoCompra: "Individual",
      idOpticaOrigen: "",
      idProveedor: "",
      nombreOpticaOrigen: "",
      borrador: true,
    });
    setCurrentProductFeatures([
      { familia: 0, productos: [] },
      { familia: 1, productos: [] },
      { familia: 2, productos: [] },
      { familia: 3, productos: [] },
      { familia: 4, productos: [] },
      { familia: 5, productos: [] },
      { familia: 6, productos: [] },
    ]);
    setRegProds(false);
    setCurrentPurchaseData([
      { familia: 0, productos: [] },
      { familia: 1, productos: [] },
      { familia: 2, productos: [] },
      { familia: 3, productos: [] },
      { familia: 4, productos: [] },
      { familia: 5, productos: [] },
      { familia: 6, productos: [] },
    ]);
    setCurrentSalesData([
      { familia: 0, productos: [] },
      { familia: 1, productos: [] },
      { familia: 2, productos: [] },
      { familia: 3, productos: [] },
      { familia: 4, productos: [] },
      { familia: 5, productos: [] },
      { familia: 6, productos: [] },
    ]);
    setCurrentStockDistribution([
      { familia: 0, productos: [] },
      { familia: 1, productos: [] },
      { familia: 2, productos: [] },
      { familia: 3, productos: [] },
      { familia: 4, productos: [] },
      { familia: 5, productos: [] },
      { familia: 6, productos: [] },
    ]);
  }

  function generateValidationOpticColumns(productList) {
    const opticColumns = [];
    const allOptics = productList[0]?.opticas || [];

    opticColumns.push(
      ...allOptics.map((optica) => ({
        name: optica.nombreCorto,
        selector: (row) =>
          row.opticas.find((o) => o.idOptica === optica.idOptica)?.stock || 0,
        sortable: true,
        width: "60px",
        style: rightStyle,
      })),
    );

    const dynamicName = productList.find(
      (p) => p.modelo || p.nombreComercial || p.producto,
    )?.modelo
      ? "Modelo"
      : productList.find((p) => p.nombreComercial)
        ? "Nombre comercial"
        : "Producto";

    const cols = [...validationColumns];

    const colsAux = cols.map((col) => {
      if (col.name === "Modelo") {
        return {
          ...col,
          name: dynamicName,
        };
      }
      return col;
    });

    const extracted = colsAux.splice(7, 3);

    const combinedColumns = [...colsAux, ...opticColumns, ...extracted];

    return combinedColumns;
  }

  function generateValidationSummaryColumns(productList) {
    const allOptics = productList[0]?.opticas || [];
    if (allOptics.length === 0) return validationSummaryColumns;

    const opticCols = allOptics.map((optica) => ({
      name: optica.nombreCorto,
      selector: (row) =>
        row.opticas?.find((o) => o.idOptica === optica.idOptica)?.stock ?? 0,
      sortable: false,
      width: "60px",
      style: rightStyle,
      right: true,
    }));

    return [
      { name: "", selector: () => {}, sortable: false, width: "41%" },
      {
        name: "Stock total",
        selector: (row) => formatValueUnit(row.stockTotal),
        sortable: false,
        style: rightStyle,
        right: true,
        width: "4%",
      },
      ...opticCols,
      {
        name: "PCB total",
        selector: (row) => formatValueUnit(row.pcbTotal, "€"),
        sortable: false,
        style: rightStyle,
        right: true,
        width: "auto",
      },
      {
        name: "PCN total",
        selector: (row) => formatValueUnit(row.pcnTotal, "€"),
        sortable: false,
        style: rightStyle,
        right: true,
        width: "auto",
      },
      {
        name: "PVP total",
        selector: (row) => formatValueUnit(row.pvpTotal, "€"),
        sortable: false,
        style: rightStyle,
        right: true,
        width: "auto",
      },
    ];
  }

  function calculateValidationSummaryValues(productList) {
    const pcbTotal = productList.reduce(
      (sum, p) => sum + (Number(p.pcb) || 0) * (Number(p.stock) || 0),
      0,
    );
    const pcnTotal = productList.reduce(
      (sum, p) => sum + (Number(p.pcn) || 0) * (Number(p.stock) || 0),
      0,
    );
    const pvpTotal = productList.reduce(
      (sum, p) => sum + (Number(p.pvp) || 0) * (Number(p.stock) || 0),
      0,
    );
    const stockTotal = productList.reduce(
      (sum, p) => sum + (Number(p.stock) || 0),
      0,
    );

    const allOptics = productList[0]?.opticas || [];
    const opticTotals = allOptics.map((optica) => ({
      idOptica: optica.idOptica,
      stock: productList.reduce(
        (sum, p) =>
          sum +
          (Number(
            p.opticas?.find((o) => o.idOptica === optica.idOptica)?.stock,
          ) || 0),
        0,
      ),
    }));

    const summaryObj = {
      pcbTotal: parseFloat(pcbTotal.toFixed(2)),
      pcnTotal: parseFloat(pcnTotal.toFixed(2)),
      pvpTotal: parseFloat(pvpTotal.toFixed(2)),
      stockTotal,
      opticas: opticTotals,
    };

    return summaryObj;
  }

  async function validateDeliveryNote() {
    const response = await post("support-extra/albaran/ValidarAlbaran.php", {
      token: userData.token,
      idAlbaran: currentId,
      idUsuario: userData.id,
    });
    return response;
  }

  function showDuplicatesPopup(duplicados) {
    createPopupQuestion(
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <span>
          Atención. Se han encontrado los siguientes productos duplicados.
          Vuelva a características de producto para realizar correcciones.
        </span>
        <DataTable
          columns={[
            {
              name: "En almacén",
              selector: (row) =>
                row.codigoOPTIWIN
                  ? `${row.codigoOPTIWIN} - ${row.descripcion}`
                  : row.descripcion,
              sortable: true,
            },
            {
              name: "En creación/edición",
              selector: (row) =>
                row.codigoDuplicado
                  ? `${row.codigoDuplicado} - ${row.descripcionDuplicado}`
                  : row.descripcionDuplicado,
              sortable: true,
            },
            {
              name: "",
              sortable: false,
              width: "40px",
              style: rightStyle,
              cell: (row, rowIndex) =>
                row.diferenteEANUPC && (
                  <>
                    <img
                      src="/images/support-extra/flecha-albaran-ean-upc.svg"
                      data-tooltip-id={`dup-ean-upc-${rowIndex}`}
                      style={{
                        width: "20px",
                        cursor: "pointer",
                      }}
                      alt="Aplicar EAN / UPC"
                      onClick={() => {
                        createPopupQuestion(
                          `Se asignará código EAN / UPC ${row.codigoDuplicado} al producto con código ${row.codigoOPTIWIN} y se ajustará el albarán al producto ${row.codigoOPTIWIN} - ${row.descripcion}. ¿Desea continuar?`,
                          async () => {
                            await post(
                              "support-extra/albaran/CorregirEANUPCAlbaran.php",
                              {
                                token: userData.token,
                                idAlbaran: currentId,
                                codigoOPTIWIN: row.codigoOPTIWIN,
                                codigoEANUPC: row.codigoDuplicado,
                                idUsuario: userData.id,
                              },
                            );
                            await getDeliveryNoteAttributes();
                            await getPurchaseDeliveryNoteData();
                            await getDeliveryNoteStockDistribution();
                            await getSalesDeliveryNoteData();
                            createPopupQuestion(
                              `Se ha ajustado el código EAN / UPC del producto ${row.codigoOPTIWIN}. Revise el albarán y valide de nuevo.`,
                              () => {
                                showDuplicatesPopup(duplicados);
                              },
                              null,
                              "Entendido",
                            );
                          },
                          () => {
                            showDuplicatesPopup(duplicados);
                          },
                          "Aplicar",
                          "Cancelar",
                        );
                      }}
                    ></img>
                    <TooltipBox
                      id={`dup-ean-upc-${rowIndex}`}
                      content="Aplicar EAN / UPC"
                    ></TooltipBox>
                  </>
                ),
            },
          ]}
          data={duplicados}
          className="custom-datatable"
          noDataComponent="No hay productos duplicados."
        />
      </div>,
      removePopupQuestion,
      null,
      "Entendido",
    );
  }

  const loadCatalogues = async () => {
    const response = await post("ListarCatalogos.php", {});
    setCatalogues(response);
  };

  const openCataloguesPopup = (show) => {
    if (show) {
      loadCatalogues();
    }
    setShowCataloguesPopup(show);
  };

  useEffect(() => {
    const summaryList = currentPurchaseData.map((e) => {
      if (e.productos.length > 0) {
        return {
          idProductoAlbaran: "summary",
          pcn: e.productos.reduce(
            (sum, item) =>
              item.idProductoAlbaran !== "summary"
                ? sum + parseFloat(item.pcn)
                : sum,
            0,
          ),
          iva: e.productos.reduce(
            (sum, item) =>
              item.idProductoAlbaran !== "summary" ? sum + item.iva : sum,
            0,
          ),
          pcu: e.productos.reduce(
            (sum, item) =>
              item.idProductoAlbaran !== "summary" ? sum + item.pcu : sum,
            0,
          ),
          recargo: e.productos.reduce(
            (sum, item) =>
              item.idProductoAlbaran !== "summary" ? sum + item.recargo : sum,
            0,
          ),
          stock: e.productos.reduce(
            (sum, item) =>
              item.idProductoAlbaran !== "summary" ? sum + item.stock : sum,
            0,
          ),
          totalCompra: e.productos.reduce(
            (sum, item) =>
              item.idProductoAlbaran !== "summary"
                ? sum + item.totalCompra
                : sum,
            0,
          ),
        };
      } else {
        return {
          idProductoAlbaran: "summary",
          iva: 0,
          pcn: 0,
          pcu: 0,
          recargo: 0,
          stock: 0,
          totalCompra: 0,
        };
      }
    });

    setPurchaseSummary(summaryList);
  }, [currentPurchaseData]);

  useEffect(() => {
    const summaryObj = currentPurchaseData.reduce(
      (acc, familia) => {
        familia.productos.forEach((producto) => {
          const stock = Number(producto.stock) || 0;
          const iva = Number(producto.iva) || 0;
          const pcn = Number(producto.pcn) || 0;
          const totalCompra = Number(producto.totalCompra) || 0;

          acc.ivaTotal += iva * stock;
          acc.pcnTotal += pcn * stock;
          acc.importeTotal += totalCompra;
        });
        return acc;
      },
      { ivaTotal: 0, pcnTotal: 0, importeTotal: 0 },
    );
    setFinalPurchaseSummary([summaryObj]);
  }, [purchaseSummary]);

  useEffect(() => {
    const initializeData = async () => {
      setLoading(true);

      await initializeStructures();

      await getDeliveryNoteHeader();
      await getDeliveryNoteAttributes();
      await getPurchaseDeliveryNoteData();
      await getSalesDeliveryNoteData();
      await getDeliveryNoteStockDistribution();
      await getLabelEncodingDeliveryNoteData();

      setLoading(false);
    };

    initializeData();
  }, []);

  useEffect(() => {
    getDeliveryNoteAttributes();
    getPurchaseDeliveryNoteData();
    getSalesDeliveryNoteData();
    getDeliveryNoteStockDistribution();
    getLabelEncodingDeliveryNoteData();
  }, [createdProducts]);

  useEffect(() => {
    const allProductsEmpty =
      currentProductFeatures.length > 0 &&
      currentProductFeatures.every((e) => e.productos.length === 0);
    setRegProds(!allProductsEmpty);
  }, [currentProductFeatures]);

  useEffect(() => {
    if (
      currentPurchaseData.some((data) => data.familia && data.productos) &&
      currentStockDistribution.some((data) => data.familia && data.productos) &&
      currentSalesData.some((data) => data.familia && data.productos)
    ) {
      refineProductsForValidation();
    }
  }, [currentPurchaseData, currentStockDistribution, currentSalesData]);

  useEffect(() => {
    const globalSummary = currentValidationData
      .filter((e) => e.productos.length > 0)
      .reduce(
        (acc, family) => {
          family.productos.forEach((producto) => {
            const stock = Number(producto.stock) || 0;
            const pcn = Number(producto.pcn) || 0;
            const pcb = Number(producto.pcb) || 0;

            acc.stockTotal += stock;
            acc.pcnTotal += pcn * stock;
            acc.pcbTotal += pcb * stock;
          });
          return acc;
        },
        { stockTotal: 0, pcnTotal: 0, pcbTotal: 0 },
      );

    const roundedSummary = {
      stockTotal: globalSummary.stockTotal,
      pcnTotal: parseFloat(globalSummary.pcnTotal.toFixed(2)),
      pcbTotal: parseFloat(globalSummary.pcbTotal.toFixed(2)),
    };

    setFinalValidationSummary([roundedSummary]);
  }, [currentValidationData]);

  useEffect(() => {
    const reloadData = async () => {
      if (
        !areObjectsEqual(currentProductFeatures, currentProductFeaturesFixed)
      ) {
        await saveProductFeatures();
        await getPurchaseDeliveryNoteData();
        await getSalesDeliveryNoteData();
        await getDeliveryNoteStockDistribution();
        await getLabelEncodingDeliveryNoteData();
      }
    };

    reloadData();
  }, [currentProductFeatures]);

  return (
    <div className="external-window-bg">
      <div className="external-window external-window-suppliers">
        <div className="external-window-header">
          <button
            className="popup-action-icon close-icon"
            onClick={async () => {
              if (
                !areObjectsEqual(currentHeader, currentHeaderFixed) ||
                !areObjectsEqual(
                  currentPurchaseData,
                  currentPurchaseDataFixed,
                ) ||
                !areObjectsEqual(
                  currentStockDistribution,
                  currentStockDistributionFixed,
                ) ||
                !areObjectsEqual(currentSalesData, currentSalesDataFixed)
              ) {
                createPopupQuestion(
                  `Se han detectado cambios. ¿Desea guardar la ficha de albarán antes de salir?`,
                  async () => {
                    const ok = await saveDeliveryNote();
                    if (ok) {
                      removePopupQuestion();
                      onClose();
                    }
                  },
                  () => {
                    removePopupQuestion();
                    onClose();
                  },
                  "Sí",
                  "No",
                );
              } else {
                onClose();
              }
            }}
          >
            <img src="/images/close-white.svg" loading="lazy" alt="Icon"></img>
          </button>
          <span
            className="popup-screen-header-title"
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <img
              style={{ height: 15 }}
              src={"../images/delivery-note-white.svg"}
            ></img>
            {"Albarán"}
          </span>
        </div>
        {loading && (
          <LoadingScreen message="Cargando albarán..."></LoadingScreen>
        )}
        {!loading &&
          currentHeader &&
          currentProductFeatures &&
          currentPurchaseData &&
          currentSalesData && (
            <div className="product-container albaran-data">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                {currentHeader && (
                  <DeliveryNoteHeader
                    data={currentHeader}
                    onChange={(e) => {
                      setCurrentHeader(e);
                    }}
                  ></DeliveryNoteHeader>
                )}
                <DeliveryNoteOptionsBox
                  step={currentStep}
                  draft={currentHeader.borrador}
                  disabled={currentHeader.idProveedor === ""}
                  onStartReading={handleStartReading}
                  onSave={() => {
                    handleSave(false);
                  }}
                  onManualCreation={() => {
                    openProductPanel(
                      -1,
                      -1,
                      () => {},
                      currentHeader.idProveedor,
                      [],
                    );
                  }}
                  onDelete={deleteDeliveryNote}
                  onClickCatalogues={() => openCataloguesPopup(true)}
                ></DeliveryNoteOptionsBox>
              </div>
              <div>
                <DeliveryNoteStepHandler
                  step={currentStep}
                  onNextStep={async () => {
                    if (
                      !areObjectsEqual(
                        currentProductFeatures,
                        currentProductFeaturesFixed,
                      )
                    ) {
                      await saveProductFeatures();
                      await getPurchaseDeliveryNoteData();
                      await getSalesDeliveryNoteData();
                      await getDeliveryNoteStockDistribution();
                      await getLabelEncodingDeliveryNoteData();
                    }
                    handleNextStep();
                  }}
                  onPreviousStep={handlePreviousStep}
                  disabled={currentHeader.idProveedor === ""}
                ></DeliveryNoteStepHandler>
                {startReading && currentStep === 0 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <CodeScanningPanel
                      deliveryNoteId={currentId}
                      supplierId={currentHeader.idProveedor}
                      onClose={handleCloseScanningPanel}
                      onRegister={registerProduct}
                      createPopupQuestion={createPopupQuestion}
                      removePopupQuestion={removePopupQuestion}
                    ></CodeScanningPanel>
                  </div>
                )}
                {!regProds && (
                  <div style={{ textAlign: "center", marginTop: "20px" }}>
                    Debe registrar productos en el albarán antes de continuar.
                    Pulse el botón de iniciar lectura o inserte de forma manual.
                  </div>
                )}
                {/* PASO 1: Características de producto */}
                {currentStep === 0 && (
                  <div className="delivery-note-step-container albaran-step1">
                    {currentProductFeatures.map((e, i) => {
                      if (e.productos.length > 0) {
                        const productFamily = selectProductName(e.familia);
                        const productList = e.productos;
                        const productFamilyColumns =
                          selectProductFamilyColumnsStep1(e.familia);
                        const tabStart = globalTabIndex;
                        const totalInputs = productList.length;
                        globalTabIndex += totalInputs;
                        return (
                          <ProductFeatures
                            family={e.familia}
                            productFamilyName={productFamily}
                            list={productList}
                            columns={productFamilyColumns}
                            key={i}
                            onDelete={deleteProduct}
                            onDeleteAll={deleteAllProducts}
                            createPopupQuestion={createPopupQuestion}
                            removePopupQuestion={removePopupQuestion}
                            draft={currentHeader.borrador}
                            tabStartIndex={tabStart}
                            onChange={(updatedProducts) => {
                              setCurrentProductFeatures((prev) =>
                                prev.map((feature) =>
                                  feature.familia === e.familia
                                    ? { ...feature, productos: updatedProducts }
                                    : feature,
                                ),
                              );
                            }}
                          ></ProductFeatures>
                        );
                      }
                    })}
                  </div>
                )}
                {/* Paso 2: Datos de compra */}
                {currentStep === 1 && (
                  <div className="delivery-note-step-container albaran-step2">
                    {currentPurchaseData.map((e, i) => {
                      if (e.productos.length > 0) {
                        const productFamily = selectProductName(e.familia);
                        const productList = e.productos;
                        const productFamilyColumns =
                          selectProductFamilyColumnsStep2(e.familia);
                        const tabStart = globalTabIndex;
                        const totalInputs = 5 + productList.length * 3;
                        globalTabIndex += totalInputs;
                        return (
                          <ProductPurchaseData
                            productFamilyId={e.familia}
                            productFamilyName={productFamily}
                            list={productList}
                            columns={productFamilyColumns(
                              InputData,
                              CheckBox,
                              toggleSelector,
                            )}
                            onProductChange={handlePurchaseProductChange}
                            key={i}
                            tabStartIndex={tabStart}
                            createPopupQuestion={createPopupQuestion}
                            removePopupQuestion={removePopupQuestion}
                          ></ProductPurchaseData>
                        );
                      }
                    })}
                    <div className="store-products-table delivery-note-table">
                      <div className="opt-table-title">Resumen</div>
                      <DataTable
                        columns={purchaseSummaryColumns}
                        data={finalPurchaseSummary}
                        className="custom-datatable"
                        noDataComponent="No hay datos disponibles."
                        onRowClicked={(row, event) => {}}
                      />
                    </div>
                  </div>
                )}
                {/* PASO 3: Distribución de stock */}
                {currentStep === 2 && (
                  <div className="delivery-note-step-container albaran-step3">
                    <div className="stock-distribution-ops">
                      <div className="data-field">
                        <span className="label">Distribución stock</span>
                        <Dropdown
                          tabIndex={52}
                          optionList={[
                            { id: "Individual", text: "INDIVIDUAL" },
                            { id: "Multicompra", text: "MULTICOMPRA" },
                          ]}
                          size={2}
                          /* disabled={!currentHeader.borrador} */
                          op={selectedDistributionStock}
                          onChange={(e) => {
                            setSelectedDistributionStock(e.id);
                          }}
                        ></Dropdown>
                      </div>
                    </div>
                    {selectedDistributionStock !== "Individual" &&
                      currentStockDistribution.map((e, i) => {
                        if (e.productos.length > 0) {
                          const productFamily = selectProductName(e.familia);
                          const productList = e.productos;
                          const productFamilyColumns =
                            selectProductFamilyColumnsStep3(e.familia);
                          return (
                            <ProductStockDistribution
                              productFamilyId={e.familia}
                              productFamilyName={productFamily}
                              distributionOption={selectedDistributionStock}
                              list={productList}
                              columns={productFamilyColumns}
                              key={i}
                              createPopupQuestion={createPopupQuestion}
                              removePopupQuestion={removePopupQuestion}
                              opticList={opticalList}
                              onProductChange={
                                handleStockDistributionProductChange
                              }
                            ></ProductStockDistribution>
                          );
                        }
                      })}
                  </div>
                )}
                {/* Paso 4: Datos de venta */}
                {currentStep === 3 && (
                  <div className="delivery-note-step-container albaran-step4">
                    {currentSalesData.map((e, i) => {
                      if (e.productos.length > 0) {
                        const productFamily = selectProductName(e.familia);
                        const productList = e.productos;
                        const productFamilyColumns =
                          selectProductFamilyColumnsStep4(e.familia);
                        const tabStart = globalTabIndex;
                        const totalInputs = 3 + productList.length * 2;
                        globalTabIndex += totalInputs;
                        return (
                          <ProductSalesData
                            productFamilyId={e.familia}
                            productFamilyName={productFamily}
                            supplierId={currentHeader.idProveedor}
                            list={productList}
                            columns={productFamilyColumns(
                              InputData,
                              CheckBox,
                              toggleSelector,
                            )}
                            key={i}
                            onProductChange={handleSalesProductChange}
                            tabStartIndex={tabStart}
                          ></ProductSalesData>
                        );
                      }
                    })}
                  </div>
                )}
                {/* PASO 5: Resumen de albarán y validación */}
                {currentStep === 4 && (
                  <div className="delivery-note-step-container albaran-step5">
                    {currentHeader.borrador && (
                      <div className="stock-distribution-buttons-container">
                        <ButtonIconH
                          text="Validar"
                          onClick={async () => {
                            const saveOK = await saveDeliveryNote();
                            if (saveOK) {
                              const response = await validateDeliveryNote();
                              if (response.duplicados.length === 0) {
                                setCurrentHeader((prev) => ({
                                  ...prev,
                                  borrador: false,
                                }));
                                setCurrentHeaderFixed((prev) => ({
                                  ...prev,
                                  borrador: false,
                                }));
                                await getLabelEncodingDeliveryNoteData();
                                createPopupQuestion(
                                  `La ficha de albarán se ha validado correctamente.`,
                                  removePopupQuestion,
                                  null,
                                  "Entendido",
                                );
                              } else {
                                showDuplicatesPopup(response.duplicados);
                              }
                            }
                          }}
                        ></ButtonIconH>
                      </div>
                    )}
                    {currentValidationData.map((e, i) => {
                      if (e.productos.length > 0) {
                        const productFamily = selectProductName(e.familia);
                        const productList = e.productos;

                        const combinedColumns =
                          selectedDistributionStock === "Individual"
                            ? [...validationColumns]
                            : generateValidationOpticColumns(productList);

                        const summaryRow =
                          calculateValidationSummaryValues(productList);

                        const summaryColumns =
                          selectedDistributionStock === "Individual"
                            ? validationSummaryColumns
                            : generateValidationSummaryColumns(productList);

                        return (
                          <DeliveryNoteValidation
                            productFamilyName={productFamily}
                            columns={combinedColumns}
                            list={productList}
                            key={i}
                            summaryColumns={summaryColumns}
                            summaryData={[summaryRow]}
                          />
                        );
                      }
                    })}
                    <div className="section-content-sep"></div>
                    <div
                      className="store-products-table delivery-note-table"
                      style={{
                        marginBottom: "20px",
                      }}
                    >
                      <div className="opt-table-title">Resumen</div>
                      <DataTable
                        columns={validationFinalSummaryColumns}
                        data={finalValidationSummary}
                        className="custom-datatable"
                        noDataComponent="No hay datos disponibles."
                        onRowClicked={(row, event) => {}}
                      />
                    </div>
                  </div>
                )}
                {/* PASO 6: Codificación */}
                {currentStep === 5 && (
                  <div className="delivery-note-step-container albaran-step6">
                    {currentLabelEncoding.map((e, i) => {
                      if (e.productos.length > 0) {
                        const productFamily = selectProductName(e.familia);
                        const productList = e.productos;
                        const productFamilyColumns =
                          selectProductFamilyColumnsStep6(e.familia);

                        return (
                          <DeliveryNoteLabelEncoding
                            deliveryNoteId={currentId}
                            selectedDistributionStock={
                              selectedDistributionStock
                            }
                            productFamilyId={e.familia}
                            productFamilyName={productFamily}
                            columns={productFamilyColumns(
                              InputData,
                              CheckBox,
                              toggleSelector,
                            )}
                            list={productList}
                            key={i}
                            createPopupQuestion={createPopupQuestion}
                            removePopupQuestion={removePopupQuestion}
                          />
                        );
                      }
                    })}
                  </div>
                )}
              </div>
            </div>
          )}
      </div>
      {showCataloguesPopup && (
        <div className="popup-container secondary catalogue-list">
          <div className="popup-message">
            <div className="popup-calendario">
              <PopupTitle
                title="Catálogos centralizados"
                onClose={() => openCataloguesPopup(false)}
              />
            </div>
            <div className="popup-calendar-body">
              {Array.from(
                { length: Math.ceil(catalogues.length / 2) },
                (_, i) => (
                  <div key={i} className="catalogue-row">
                    {catalogues.slice(i * 2, i * 2 + 2).map((catalogue, j) => (
                      <CatalogueItem
                        key={j}
                        logo={catalogue.logo}
                        proveedor={catalogue.proveedor}
                        ultimaActualizacion={catalogue.ultimaActualizacion}
                      />
                    ))}
                  </div>
                ),
              )}
              <div className="popup-row-buttons-container">
                <div className="popup-row-buttons">
                  <ButtonIconH
                    text="Cerrar"
                    onClick={() => openCataloguesPopup(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
